var _clipPath, _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgDelete = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17.302,
    height: 17.302,
    viewBox: "0 0 17.302 17.302",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H17.302V17.302H0z",
    style: {
      fill: "none"
    }
  })), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix___Icon_\\u0421olor",
    d: "M12.977 17.3H4.326a2.6 2.6 0 0 1-2.6-2.6V5.191H.865a.865.865 0 0 1 0-1.731h4.326V2.014A2.094 2.094 0 0 1 7.353 0h2.6a2.1 2.1 0 0 1 2.163 2.014V3.46h4.325a.865.865 0 0 1 0 1.731h-.865v9.516a2.6 2.6 0 0 1-2.599 2.593zM3.46 5.191v9.516a.866.866 0 0 0 .866.865h8.651a.866.866 0 0 0 .865-.865V5.191zM7.353 1.73c-.247 0-.432.15-.432.284V3.46h3.459V2.014c0-.134-.185-.284-.432-.284zm3.893 11.247a.866.866 0 0 1-.865-.865V8.651a.865.865 0 0 1 1.731 0v3.461a.866.866 0 0 1-.866.865zm-5.19 0a.866.866 0 0 1-.865-.865V8.651a.865.865 0 1 1 1.73 0v3.461a.866.866 0 0 1-.865.865z",
    className: "prefix__cls-1",
    "data-name": "\\uD83C\\uDFA8 Icon \\u0421olor"
  }))), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\r\n            .prefix__cls-1{fill:#007dc3}\r\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "prefix__trash-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix___Icon_\\u0421olor-2",
    d: "M12.977 17.3H4.326a2.6 2.6 0 0 1-2.6-2.6V5.191H.865a.865.865 0 0 1 0-1.731h4.326V2.014A2.094 2.094 0 0 1 7.353 0h2.6a2.1 2.1 0 0 1 2.163 2.014V3.46h4.325a.865.865 0 0 1 0 1.731h-.865v9.516a2.6 2.6 0 0 1-2.599 2.593zM3.46 5.191v9.516a.866.866 0 0 0 .866.865h8.651a.866.866 0 0 0 .865-.865V5.191zM7.353 1.73c-.247 0-.432.15-.432.284V3.46h3.459V2.014c0-.134-.185-.284-.432-.284zm3.893 11.247a.866.866 0 0 1-.865-.865V8.651a.865.865 0 0 1 1.731 0v3.461a.866.866 0 0 1-.866.865zm-5.19 0a.866.866 0 0 1-.865-.865V8.651a.865.865 0 1 1 1.73 0v3.461a.866.866 0 0 1-.865.865z",
    className: "prefix__cls-1",
    "data-name": "\\uD83C\\uDFA8 Icon \\u0421olor"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDelete, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/delete.2a0c7843.svg";
export { ForwardRef as ReactComponent };